import { render, staticRenderFns } from "./OzBaseSnackbar.vue?vue&type=template&id=c1fb8bf2&"
import script from "./OzBaseSnackbar.vue?vue&type=script&lang=ts&"
export * from "./OzBaseSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports